<template>
  <div class="text-white min-h-full">
    <header class="w-full p-6">
      <router-link to="/">
        <img
          src="/reeltrack-orange.svg"
          alt="ReelTrack"
          class="h-12"
          width="180"
          height="48"
        />
      </router-link>
    </header>

    <main class="flex justify-center px-6 pb-16">
      <div class="w-full max-w-md">
        <h1 class="text-3xl font-semibold">{{ title }}</h1>
        <p v-if="subtitle" class="text-muted mt-2 text-sm leading-relaxed">
          {{ subtitle }}
        </p>

        <div class="mt-8">
          <slot />
        </div>

        <!-- Every auth page needs a way back to sign-in. -->
        <p v-if="showBack" class="mt-10 text-sm">
          <router-link to="/login" class="text-highlight hover:underline">
            {{ $t("auth.backToLogin") }}
          </router-link>
        </p>
      </div>
    </main>
  </div>
</template>

<script>
export default {
  name: "AuthLayout",
  props: {
    title: { type: String, required: true },
    subtitle: { type: String, default: "" },
    showBack: { type: Boolean, default: true },
  },
};
</script>
